import { css, keyframes } from 'styled-components';

// Keyframe animations
export const float = keyframes`
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
`;

export const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

export const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

// Animation mixins
export const floatAnimation = css`
  animation: ${float} 3s ease-in-out infinite;
`;

export const rotateAnimation = css`
  animation: ${rotate} 20s linear infinite;
`;

export const shimmerAnimation = css`
  animation: ${shimmer} 3s linear infinite;
`;

export const fadeInAnimation = css`
  animation: ${fadeIn} 0.6s ease-out forwards;
`;

export const pulseAnimation = css`
  animation: ${pulse} 2s ease-in-out infinite;
`;

// Hover effects
export const hoverScale = css`
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const hoverLift = css`
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(124, 58, 237, 0.3);
  }
`;
